module.exports = __webpack_public_path__ + "7e175a9f841a925f7c0051a035a4d52a.fbx";